import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ShoppingBag, X, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShopPopup() {
  const [product, setProduct] = useState(null);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem("gg_shop_popup_dismissed")) return;

    // Check if popup is enabled
    axios.get(`${API}/shop-settings`).then((s) => {
      if (s.data.popup_enabled === false) return;
      axios.get(`${API}/products`).then((r) => {
        if (r.data.length > 0) {
          const randomProduct = r.data[Math.floor(Math.random() * r.data.length)];
          setProduct(randomProduct);
          const timer = setTimeout(() => setVisible(true), 8000);
          return () => clearTimeout(timer);
        }
      }).catch(() => {});
    }).catch(() => {});
  }, []);

  const dismiss = () => {
    setDismissed(true);
    setVisible(false);
    sessionStorage.setItem("gg_shop_popup_dismissed", "1");
  };

  if (!product || dismissed) return null;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ x: 300, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          exit={{ x: 300, opacity: 0 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="fixed bottom-36 right-4 sm:right-6 z-40 w-[200px]"
          data-testid="shop-popup"
        >
          <div className="bg-gg-surface border border-white/10 rounded-xl overflow-hidden shadow-2xl shadow-black/40">
            <button onClick={dismiss} className="absolute top-1.5 right-1.5 z-10 w-5 h-5 rounded-full bg-black/50 backdrop-blur flex items-center justify-center text-zinc-400 hover:text-white transition-colors" data-testid="shop-popup-close">
              <X size={10} />
            </button>

            {product.image_url && (
              <div className="w-full">
                <img src={product.image_url} alt={product.name} className="w-full aspect-square object-cover" />
              </div>
            )}

            <div className="p-2.5">
              <div className="flex items-center gap-1 mb-1">
                <ShoppingBag size={9} className="text-gg-red" />
                <span className="text-[7px] font-heading uppercase tracking-widest text-gg-red">New in Shop</span>
              </div>
              <h4 className="font-heading text-[10px] font-bold uppercase tracking-wide text-white truncate">{product.name}</h4>
              <p className="text-gg-red font-heading font-bold text-xs mt-0.5">Rs.{product.price}</p>
              <Link to="/shop" onClick={dismiss} className="mt-1.5 w-full inline-flex items-center justify-center gap-1 bg-gg-red hover:bg-gg-red-hover text-white text-[8px] font-heading uppercase tracking-widest py-1.5 rounded-lg transition-all duration-300 group" data-testid="shop-popup-cta">
                Shop Now <ArrowRight size={10} className="group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
